<template lang="pug">
    extends ../base/base.pug
    block input
        div(v-bind:class="{ 'text-danger': is_error }")
            div
                = '{{ question }}'
            div.text-danger(v-if="is_error")
                span(v-html='error_message')
            b-card-group(deck v-if="count > 0")
                template(v-for="(value, i) in data")
                    b-card.multiFieldCardStyle(header-tag="header" no-body)
                        div(slot="header")
                            b-btn(v-if="(count > (minAllowed || 0))" @click="process_delete(i)" size="sm" class="float-right")
                                | Remove
                        component(
                        v-bind:key="i + '_' + new Date().getUTCMilliseconds()"
                        v-bind:is="slug"
                        v-bind:multi_field_num="++i"
                        v-on:trigger-delete="process_delete"
                        )
            div.m-3
                b-btn(v-if="count < maxAllowed" v-on:click="add_child()" size="sm")
                    | {{ addAnotherText }}
</template>
<script>
import Base from "../base";
import q_college from "../../questions/q_college";
import q_high_school from "../../questions/q_high_school";
import q_parent from "../../questions/q_parent";
import q_guardian from "../../questions/q_guardian";
import q_work from "../../questions/q_work";
import q_community from "../../questions/q_community";
import q_clubs from "../../questions/q_clubs";
import q_awards from "../../questions/q_awards";
import q_arts from "../../questions/q_arts";
import q_athletics from "../../questions/q_athletics";
import q_publications from "../../questions/q_publications";
import q_relative from "../../questions/q_relative";

export default {
	extends: Base,
	props: ["minAllowed", "maxAllowed", "addAnotherString"],
	components: {
		q_college,
		q_high_school,
		q_parent,
		q_guardian,
		q_work,
		q_community,
		q_clubs,
		q_awards,
		q_arts,
		q_athletics,
		q_publications,
		q_relative
	},
	computed: {
		data() {
			return this.$store.getters[this.slug + "/answer"];
		},
		count() {
			let count = 1;
			if (this.data) {
				count = this.data.length;
			}

			return count;
		},
		addAnotherText() {
			if (
				"addAnotherString" in this &&
				typeof this.addAnotherString !== "undefined" &&
				this.addAnotherString.length > 0
			) {
				return this.addAnotherString;
			}
			return "Add another";
		}
	},
	methods: {
		add_child() {
			this.$store.dispatch(this.slug + "/add_item", this.slug);
		},
		process_delete(multi_field_num) {
			let payload = {
				slug: this.slug,
				item_num: multi_field_num
			};
			this.$store.dispatch(this.slug + "/delete_item", payload);
		}
	},
	mounted() {
		this.$store.dispatch(this.slug + "/get_empty_item", this.slug);
	}
};
</script>
<style scoped>
.multiFieldCardStyle {
	min-width: 30rem;
	max-width: 45rem;
}

.text-danger .card-deck .multiFieldCardStyle {
	border-color: #800000 !important;
}
</style>
